export const OWNER_ID = ['ownerId'];